import { Navigate, useLocation } from 'react-router-dom';
import { getPlatformToken } from './platformAuth';

export default function PlatformGuard({ children }) {
  const location = useLocation();
  return getPlatformToken()
    ? children
    : <Navigate replace to="/login" state={{ from: location.pathname }} />;
}

